import React from 'react'

interface MessageProps {
  body: string
  title: string
}
export const Message: React.FC<MessageProps> = ({ body, title, children }) => {
  return (
    <div style={{ color: 'red', marginTop: '20px' }}>
      <h4 style={{ textAlign: 'center', marginBottom: '5px' }}>{title}</h4>
      <p style={{ textAlign: 'center' }}>
        {body}
        {children}
      </p>
    </div>
  )
}
